import fetchWrapper from '../../helpers/fetchWrapper';
import { swalConfirm, swalError } from '../../../app/helpers/swal';
import {
	BarChartOutlined,
	DeleteOutlined,
	EllipsisOutlined,
	ExportOutlined,
	MoreOutlined,
} from '@ant-design/icons';
import { Card, Dropdown, Menu, Tooltip } from 'antd';
import { useHistory } from "react-router-dom";
import { useRef } from 'react';
import styled from 'styled-components';
import React from 'react';
import exportChart from '../WidgetCard/exportChart';
import { CardContentWrap, CardV2Wrapper } from '../styles';
import { apsisEncrypt } from '../../helpers/apsisEncryption';
function getItem(label, key, icon, children, type) {
	return {
		key,
		icon,
		children,
		label,
		type,
	};
}
export const WidgetCardV2 = (props) => {
	const exportRef = useRef();
	const history = useHistory();
	const {
		chartItem: { widget_type, data, subtitle, icon_class, theme },
		cardModuleId,
		cardUserId,
		userInfo,
		widgetId,
		moduleInfo,
	} = props;
	const filterTitle = <span style={{ fontSize: '10px' }}>Add Filter</span>;
	const fullscreenTitle = <span style={{ fontSize: '10px' }}>View in full screen</span>;
	const tblTitle = <span style={{ fontSize: '10px' }}>Table View</span>;
	const chartTitle = <span style={{ fontSize: '10px' }}>Chart View</span>;
	const exportType = (e, widgetId, mid) => {
		if (e.key === 'downloadPdf' || e.key === 'downloadImg') {
			exportChart(e.key, exportRef.current, 'chart');
		} else {
			// const userInfo = userService.userValue;
			if (moduleInfo === cardModuleId && userInfo.user_id === cardUserId) {
				widgetDelete(widgetId, mid);
			} else {
				swalError('Permision Denied!');
			}
		}
	};
	
	const itemsChart = [
		getItem('Export', 'sub2', <ExportOutlined />, [getItem('PDF', 'downloadPdf'), getItem('PNG', 'downloadImg')]),
		getItem('Delete', 'delete', <DeleteOutlined />),
	];

	const widgetDelete = (widgetId, mid) => {
		swalConfirm('Are you sure  ?').then((result) => {
			const payLoad = { dashboard_widget_id: widgetId, module_id: 22 };
			if (result.isConfirmed) {
				fetchWrapper
					.patch('/dashboard/widget-configurations/remove', payLoad)
					.then((response) => {
						if (!response.error) {
							// swalSuccess(response.message);
							history.push({
								pathname: `/`,
							});
						} else {
							swalError(response.message);
						}
					})
					.catch((error) => {
						swalError(error.message);
					});
			}
		});
	};
	
	const menu = (
		<Menu
			// onClick={(e) => exportType(e, widgetId, moduleInfo.module_id)}
			 onClick={(e) => exportType(e, widgetId, moduleInfo)}
			style={{
				width: 100,
				fontSize: '12px',
			}}
			mode="vertical"
			className="cardMenu"
			items={true ? itemsChart.filter((_, index) => index !== 2) : itemsChart}
		/>
	);

	const goMasterList = (slug) => {
		if (slug) {
			history.push(`/dashboard/list?slug=${apsisEncrypt(slug)}`);
		} else {
			history.push(`/`);
		}
	};
	return (
		<div>
			{(() => {
				switch (widget_type) {
					case 'CardV2': {
						return (
							<>
								{data?.map((item) => {
									console.log('item', item);
									// Determine icon and colors based on theme or item properties
									const getIconConfig = () => {
										switch (theme) {
											case 'successColor':
												return {
													icon: icon_class || 'fa fa-check-circle',
													iconColor: '#369b00',
													iconBgColor: '#deffcd',
												};
											case 'Warning':
												return {
													icon: icon_class || 'fa fa-exclamation-triangle',
													iconColor: '#e69b00',
													iconBgColor: '#fff0d1',
												};
											case 'infoColor':
												return {
													icon: icon_class || 'fa fa-info-circle',
													iconColor: '#2095ff',
													iconBgColor: '#dceeff',
												};
											default:
												return {
													icon: icon_class || 'fa fa-file-text',
													iconColor: '#ffffff',
													iconBgColor: theme,
												};
										}
									};

									const iconConfig = getIconConfig();

									return (
										<span ref={exportRef}>
											<CardV2Wrapper
												key={item.slug}
												iconColor={iconConfig.iconColor}
												iconBgColor={iconConfig.iconBgColor}
												onClick={() => goMasterList(item.slug)}
											>
												<div className="icon-container">
													<i className={iconConfig.icon}></i>
												</div>
												<div className="content-wrapper">
													<h3 className="title">{item.title}</h3>
													<div className="value-wrapper">
														{/* <i className="fa fa-arrow-up arrow-icon"></i> */}
														<h2 className="value">{item.value}</h2>
													</div>
													<p className="description">{subtitle || ''}</p>
												</div>
												<div
													className="dropdown-container"
													onClick={(e) => e.stopPropagation()}
												>
													<Dropdown overlay={menu} style={{ fontSize: '0.5vw' }}>
														<MoreOutlined
															style={{
																fontSize: '20px',
																marginLeft: '10px',
																cursor: 'pointer',
															}}
														/>
													</Dropdown>
												</div>
											</CardV2Wrapper>
										</span>
									);
								})}
							</>
						);
					}
					// by default Card component will be visible Warning
					default: {
						return (
							<>
								{data?.map((item) => {
									return (
										<CardContentWrap
											key={item.slug}
											theme={theme}
											onClick={() => goMasterList(item.slug)}
										>
											<h2 className="font-bold">{item.value}</h2>
											<p className="text-center">{item.title}</p>
										</CardContentWrap>
									);
								})}
							</>
						);
					}
					// code block
				}
			})()}
		</div>
	);
};
